import { logger } from '../../../common/utils/logger';

export const onPopularSearchQueryButtonClicked: () =>
	| {
			action: string;
			actionSubject: string;
			eventType: string;
	  }
	| {
			action?: undefined;
			actionSubject?: undefined;
			eventType?: undefined;
	  } = () => {
	try {
		return {
			action: 'clicked',
			actionSubject: 'popularSearchQueryButton',
			eventType: 'ui',
		};
	} catch (error) {
		logger.error({
			feature: 'bookmarks',
			element: 'container',
			operation: 'build-analytics',
			category: 'invariant',
			telemetryOnly: true,
			error,
			functionName: 'onPopularSearchQueryButtonClicked',
		});
		return {};
	}
};
